import { useContext } from 'react'
import { ReportSidebarContext, type ReportSidebarContextValue } from './ReportSidebarContextDef'

/**
 * Hook to access report sidebar controls.
 * Must be used within a ReportSidebarProvider.
 */
export function useReportSidebar(): ReportSidebarContextValue {
  const context = useContext(ReportSidebarContext)
  if (!context) {
    throw new Error('useReportSidebar must be used within a ReportSidebarProvider')
  }
  return context
}

/**
 * Optional hook that returns null if used outside provider.
 * Useful for components that may or may not be in the provider tree.
 */
export function useOptionalReportSidebar(): ReportSidebarContextValue | null {
  return useContext(ReportSidebarContext)
}
